import axios from "axios";
import jwtDecode from 'jwt-decode';
import { toInteger } from "lodash";

const API_URL = "https://smartelec.eu.org/ota_api_v2/rpc/";

const register = (email, password, honeypot, captchaToken) => {
  return axios.post(API_URL + "signup", {
    "email": email,
    "password": password,
    "honeypot": honeypot,
    "source": "web-kx",
    // "token": captchaToken
  });
};


const decodeJwtToken = (token) => {

  const decoded = jwtDecode(token);
  const email = decoded.email;
  const role = decoded.role;
  const race_username = decoded.race_username;
  const race_team = decoded.race_team;
  let tokenExpireAt = decoded.exp * 1000;

  const tokenExpireInMillis = tokenExpireAt - Date.now();
  console.log("decodeJwtToken / tokenExpireIn", tokenExpireInMillis / 1000 / 60, "/ tokenExpireAt", tokenExpireAt);

  // tokenExpireAt = Date.now() + 10000
  localStorage.setItem('tokenExpireAt', tokenExpireAt)
  // localStorage.setItem('tokenDecodedAt', Date.now()) 

  return { email, role, race_username, race_team };
}

const login = (username, password) => {
  return axios
    .post(API_URL + "login", {
      "email": username,
      "password": password
    })
    .then((response) => {
      if (response.data.token) {
        let userData = decodeJwtToken(response.data.token)
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", userData.email);
        localStorage.setItem("role", userData.role);
        localStorage.setItem("race_username", userData.race_username);
        localStorage.setItem("race_team", userData.race_team);
        localStorage.setItem("token", response.data.token);

        // Call the update_date_web_login function via the /rpc endpoint
        axios.post(API_URL + "update_date_web_login", {
          "user_id": userData.email
        }, {
          headers: {
            "Authorization": `Bearer ${response.data.token}`
          }
        })
        .catch((error) => {
          console.error("Error updating date_web_login:", error);
        });
      }

      return response.data;
    });
};

const logout = () => {
  console.log("auth.service / logout");
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("role");
  localStorage.removeItem("race_username");
  localStorage.removeItem("race_team");
  localStorage.removeItem("token");
  localStorage.removeItem("vloupk");
  /*
  return axios.post(API_URL + "signout").then((response) => {
    return response.data;
  });
  */
};

const getCurrentUser = () => {
  let data = {
    id: localStorage.getItem("user"),
    email: localStorage.getItem("user"),
    race_username: localStorage.getItem("race_username"),
    race_team: localStorage.getItem("race_team") ? toInteger(localStorage.getItem("race_team")) : 0,
    roles: [localStorage.getItem("role")],
    token: localStorage.getItem("token"),
  }
  return data

};

const changeRaceUsername = (username) => {
  localStorage.setItem("race_username", username);
}

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  changeRaceUsername
}

export default AuthService;
